import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import { Modal } from '@els/els-react--modal';
import { LEGACY_DIALOG_SIZE } from '@Containers/Dialogs/DialogsConstants';
import { headerString, zeroResultMEssage } from './ZeroFilterResultsConstants';

import './ZeroFilterResults.scss';

const ZERO_FILTER_RESULTS_MODAL_ID = 'zero-filter-results-modal';

const getInitialModalFocus = () => {
  const modalElement = document.getElementById(ZERO_FILTER_RESULTS_MODAL_ID);
  return modalElement?.querySelector('.c-els-modal__close button') || modalElement?.querySelector('[role="dialog"]');
};

export default function ZeroFilterResults({ className, selfClose, onYesClick }) {
  const handleClose = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <Modal
      id={ZERO_FILTER_RESULTS_MODAL_ID}
      className={classnames(className, 'zero-filter-results-modal')}
      label={headerString}
      width={LEGACY_DIALOG_SIZE}
      onClose={handleClose}
      shouldPreventClickOverlayToClose
      focusTrapProps={{
        focusTrapOptions: {
          initialFocus: getInitialModalFocus,
        },
      }}>
      <div>
        <header className="u-els-margin-bottom-1o2">
          <h4>{headerString}</h4>
        </header>
        <section className="zero-filter-results-modal__message u-els-margin-bottom">{zeroResultMEssage}</section>
        <footer className="o-els-flex-layout o-els-flex-layout--right o-els-flex-layout--middle">
          <Button type="primary" data-e2e="zero-filter-results-ok-button" onClick={handleClose} className="e2e-zero-filter-results-ok">
            Close
          </Button>
        </footer>
      </div>
    </Modal>
  );
}

ZeroFilterResults.propTypes = {
  className: PropTypes.string,
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
};
